export const listPricesByProduct = `
   query listPrices($productId: ID!, $filter: PricesFilterInput) {
       listPrices(productId: $productId, filter: $filter) {
           items {
              id
              productId
              priceStatus
              pricingModel
              recurringOption
              amount
              description
              billingPeriod
              providerMappings {
                items {
                  id
                  billingProviderId
                  providerEntityId
                  billingProvider {
                    key
                  }
                }
              }
           }
           nextToken
       }
   }
`;
